module.exports = __webpack_public_path__ + "static/img/close.238109e7.png";